var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "global-layout",
    { on: { dynamicRouterShow: _vm.dynamicRouterShow } },
    [
      _c("contextmenu", {
        staticStyle: { "z-index": "9999" },
        attrs: { itemList: _vm.menuItemList, visible: _vm.menuVisible },
        on: {
          "update:visible": function ($event) {
            _vm.menuVisible = $event
          },
          select: _vm.onMenuSelect,
        },
      }),
      _vm.multipage
        ? _c(
            "a-tabs",
            {
              staticClass: "tab-layout-tabs",
              attrs: {
                "active-key": _vm.activePage,
                "hide-add": true,
                type: "editable-card",
              },
              on: {
                change: _vm.changePage,
                tabClick: _vm.tabCallBack,
                edit: _vm.editPage,
              },
              nativeOn: {
                contextmenu: function ($event) {
                  return ((e) => _vm.onContextmenu(e)).apply(null, arguments)
                },
              },
            },
            _vm._l(_vm.pageList, function (page) {
              return _c(
                "a-tab-pane",
                { key: page.fullPath, attrs: { id: page.fullPath } },
                [
                  _c(
                    "span",
                    {
                      attrs: { slot: "tab", pagekey: page.fullPath },
                      slot: "tab",
                    },
                    [_vm._v(_vm._s(page.meta.title))]
                  ),
                ]
              )
            }),
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticStyle: { margin: "4px 4px 0" } },
        [
          _c(
            "transition",
            { attrs: { name: "page-toggle" } },
            [
              _vm.multipage
                ? _c(
                    "keep-alive",
                    { attrs: { include: _vm.includedComponents } },
                    [_c("router-view")],
                    1
                  )
                : [_c("router-view")],
            ],
            2
          ),
          _vm._l(_vm.hasOpenComponentsArr, function (item) {
            return _c(item.name, {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.$route.path === item.path,
                  expression: "$route.path === item.path",
                },
              ],
              key: item.name,
              tag: "component",
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }